import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import DailyRouteLeadingCountSelectionCriteriaContainer from './DailyRouteLeadingCountSelectionCriteriaContainer';
import { getLeftCheckedMailProcessingCenters, getRightCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/DailyRouteLeadingCountSelectors';
import DailyRouteLeadingCountStatusDetailsContainer from './DailyRouteLeadingCountStatusDetailsContainer';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { getGlobalEndDate, getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';

const leftTree = {
  title: 'Outbound Operator & IMPC',
};
const rightTree = {
  title: 'Inbound Operator & IMPC',
};

class DailyRouteLeadingCountContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'DAILY_ROUTE_LEADING_COUNT_SUMMARY' },
      this.props.appContext.appContext,
      {
        impcFromList: this.props.leftCheckedMailProcessingCenters,
        impcToList: this.props.rightCheckedMailProcessingCenters,
        startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
        endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
      },
    );
  };

  render() {
    const { isLoading, data, columns } = this.props;
    const { showResult, selectedEndDate, selectedStartDate } = this.state;

    return (
      <div>
        <DailyRouteLeadingCountSelectionCriteriaContainer
          open={data.length === 0}
          title="DAILY ROUTE LEADING COUNT SUMMARY"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          leftTree={leftTree}
          rightTree={rightTree}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                <ListTable
                  listId={TableDefinitions.DAILY_ROUTE_LEADING_COUNT_SUMMARY.id}
                  loading={isLoading}
                  columns={columns}
                  data={data}
                  keyField="id"
                  selectCheckbox
                  pagination
                  downloadType={downloadTypes.EXCEL}
                  getSubComponentProps={(row) => (
                    <div style={{ padding: '20px' }}>
                      <DailyRouteLeadingCountStatusDetailsContainer
                        row={row}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

DailyRouteLeadingCountContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DailyRouteLeadingCountContainer);
